// libraries
import { useEffect, useState } from 'react';
import styled from 'styled-components';

import { Avatar, Tooltip, Typography } from 'antd';
import { TeamOutlined } from '@ant-design/icons';
import * as Colors from '@ant-design/colors';

// utils
import { txt } from '../../../../locales/i18n';
import { formatDate } from '../../../../utils/date';
import { useDeviceSize } from '../../../../hooks/device-size';

// services
import * as MunicipalityService from '../../../../services/bb-api/municipality';

// get municipality from db

export function GroupPageHeader({ group }: any): JSX.Element {
	const [municipalities, setMunicipalities] = useState<Record<string, any>[]>([]);
	const isMobileDevice: boolean = useDeviceSize();

	useEffect(() => {
		async function getResources(): Promise<void> {
			const municipalities: Record<string, any>[] = await MunicipalityService.query();
			setMunicipalities(municipalities);
		}

		getResources();
	}, []);

	function getMunicipality() {
		const municipality: any = municipalities.find((municipality: Record<string, any>) => {
			return municipality.id === group.municipality_id;
		});

		return municipality?.name;
	}

	return (
		<StyledGroupHeader>
			{isMobileDevice === false && <Avatar size={48} src={group.image} icon={<TeamOutlined />} />}

			<div className="details-container">
				<h3>
					<Typography.Text ellipsis>{group.name}</Typography.Text>
					<Typography.Text type="secondary">{getMunicipality()}</Typography.Text>
				</h3>

				<Tooltip title={`${txt('global.created by')} ${group.username}`}>
					<Typography.Link ellipsis href={`/users/${group.userId}`} className="user-details-container">
						<span>{group.username}</span>
						<Typography.Text type="secondary">{group.userMunicipality}</Typography.Text>
						<Typography.Text type="secondary">{formatDate(group.created)}</Typography.Text>
					</Typography.Link>
				</Tooltip>
			</div>
		</StyledGroupHeader>
	);
}

const StyledGroupHeader = styled.section`
	display: flex;
	align-items: center;
	gap: 1em;
	padding: 1rem 2rem;

	.details-container {
		display: flex;
		flex-direction: column;

		h3 {
			margin: 0;
			display: flex;
			gap: 1ch;
		}
	}

	.user-details-container {
		color: ${Colors.blue.primary};
		display: flex;
		gap: 1ch;
	}
`;
